import React from 'react'

export const SectionE = () => {
    return (
        <>
        <section className="section-5">

        </section>
        </>
    )
}
